import { createFlatMessageLookup } from './flatMessages';

/** S06 共用既有 Travel 語系機制，不轉換使用者輸入。 */
export const expenseMessages = {
  "zh_TW": {
    "travel.expense.s06.unableToLoadTheLedgerCheckAccess": "無法讀取帳本，請確認權限、基準幣別或稍後重試。",
    "travel.expense.s06.expenseConfirmedAndIncludedInSettlement": "費用已確認，已納入正式結算。",
    "travel.expense.s06.draftSavedNoDebtHasBeenCreated": "已儲存待補，尚未產生正式欠款。",
    "travel.expense.s06.resultUnconfirmedCheckTheOriginalRequestBefore": "結果尚未確認。請先重新讀取查證，暫停其他送出。",
    "travel.expense.s06.theVersionHasChangedReloadAndReview": "資料版本已變更，請重新讀取後再確認。",
    "travel.expense.s06.youDoNotHavePermissionToManage": "目前沒有操作此帳務的權限。",
    "travel.expense.s06.unableToSaveCheckCurrencyPrecisionPayment": "無法儲存：請檢查幣別精度、付款／分攤合計、行程日與實際發生時間。",
    "travel.expense.s06.serverStateRetrievedReviewItBeforeContinuing": "已讀取伺服器實際狀態，請核對後繼續。",
    "travel.expense.s06.theOriginalResultWasNotFoundYou": "尚未找到原請求結果；可使用相同識別重試，不會自動重送或換新識別。",
    "travel.expense.s06.theOriginalRequestSucceededWithoutCreatingA": "原請求已確認成功，沒有更換識別或重複建立。",
    "travel.expense.s06.theOriginalRequestWasRejectedCheckThe": "原請求已明確被拒絕，請檢查資料後再送出。",
    "travel.expense.s06.theOriginalResultStillNeedsCheckingNo": "原請求仍須查證，請再次讀取伺服器狀態，不會自動換識別重送。",
    "travel.expense.s06.travelExpenses": "旅費記帳",
    "travel.expense.s06.loadingLedger": "正在載入帳本…",
    "travel.expense.s06.reload": "重新讀取",
    "travel.expense.s06.backToJourney": "返回行程",
    "travel.expense.s06.traveler": "旅客 {value0}",
    "travel.expense.s06.expensesAndSharing": "記帳與分攤",
    "travel.expense.s06.previousExpenses": "既有費用",
    "travel.expense.s06.expenseNavigation": "記帳層次",
    "travel.expense.s06.tripDay": "行程日",
    "travel.expense.s06.day": "第 {value0} 天 · {value1}",
    "travel.expense.s06.dateNotSet": "尚未設定日期",
    "travel.expense.s06.theJourneyTimeZoneIsMissingOr": "行程時區尚未設定或無效：預設第一天，不套用今日。確認費用前請設定有效時區。",
    "travel.expense.s06.dayIsTheDefaultOutsideTheTrip": "{value0} · {value1} · 不在行程期間時預設第一天",
    "travel.expense.s06.reloadAndApplyServerExpense": "重新讀取並套用伺服器費用",
    "travel.expense.s06.thisExpenseIsNoLongerAccessibleReopen": "原費用已不可存取，請重新開啟帳本。",
    "travel.expense.s06.latestServerDataAppliedReviewItBefore": "已套用伺服器最新資料，請重新檢查後送出。",
    "travel.expense.s06.checkOriginalRequest": "重新讀取確認原請求",
    "travel.expense.s06.retryWithOriginalRequestKey": "使用原請求識別重試",
    "travel.expense.s06.quickEntry": "快速記帳",
    "travel.expense.s06.addExpenseQuickly": "快速新增費用",
    "travel.expense.s06.amount": "金額",
    "travel.expense.s06.saveDraft": "儲存待補",
    "travel.expense.s06.enterOnlyTheAmountNowAddPayments": "只填金額即可儲存，之後補付款及分攤。",
    "travel.expense.s06.untitledExpense": "未命名費用",
    "travel.expense.s06.draftNoDebtCreated": "待補資料 · 不產生欠款",
    "travel.expense.s06.confirmed": "已確認",
    "travel.expense.s06.originalTripDayDeleted": "原行程日已刪除 · {value0}",
    "travel.expense.s06.tripDateChangedOriginalExpenseDate": "行程日日期已變更 · 原記帳日期 {value0}",
    "travel.expense.s06.paymentDetailsAdded": "已列付款明細",
    "travel.expense.s06.payerNotSet": "付款者待補",
    "travel.expense.s06.viewDetails": "查看明細",
    "travel.expense.s06.expenseDetails": "費用明細",
    "travel.expense.s06.chooseAnExpenseFromTheListFirst": "請先從記帳列表選擇費用。",
    "travel.expense.s06.expenseName": "費用名稱",
    "travel.expense.s06.originalTripDayDeletedChooseANew": "原行程日已刪除，請明確選擇新日期",
    "travel.expense.s06.baseAmount": "基礎金額",
    "travel.expense.s06.serviceFee": "服務費",
    "travel.expense.s06.discount": "折扣",
    "travel.expense.s06.totalBaseFeeDiscountPaymentsAndShares": "總額 {value0}＝基礎金額＋服務費－折扣；確認時付款與分攤合計都必須一致。",
    "travel.expense.s06.checkAmount": "請檢查金額",
    "travel.expense.s06.category": "分類",
    "travel.expense.s06.addLater": "稍後補填",
    "travel.expense.s06.actualTime": "實際發生時間（",
    "travel.expense.s06.journeyLocalTime": "行程當地時間",
    "travel.expense.s06.note": "備註",
    "travel.expense.s06.showDepartedTravelersForHistoricalExpenses": "顯示已離團旅客供歷史補記",
    "travel.expense.s06.historicalEntriesRequireVerifiedActualTimesCosts": "歷史補記需可驗證的實際發生時間，不能分攤離團後費用。",
    "travel.expense.s06.sharedPayments": "共同付款",
    "travel.expense.s06.selectTheActualPayersAndEnterEach": "請明確選取付款旅客，各自填寫代付金額。",
    "travel.expense.s06.paymentAmount": "{value0} 付款金額",
    "travel.expense.s06.totalPaid": "付款合計 {value0}",
    "travel.expense.s06.actualParticipantsAndShares": "實際參與與分攤",
    "travel.expense.s06.sharingMethod": "分攤方式",
    "travel.expense.s06.equalShares": "平均分攤",
    "travel.expense.s06.exactAmountsZeroAllowed": "個別金額（可為零）",
    "travel.expense.s06.unselectedTravelersOweNothingTheWholeGroup": "未選旅客不負擔費用；不會自動把全團加入。",
    "travel.expense.s06.shareAmount": "{value0} 分攤金額",
    "travel.expense.s06.totalShares": "分攤合計 {value0}",
    "travel.expense.s06.noTravelersSelected": "尚未選取旅客",
    "travel.expense.s06.confirmExpenseTripDayAndTimeFor": "確認費用（含行程日與時間）並納入結算",
    "travel.expense.s06.thisExpenseIsConfirmedPaymentAndShare": "此費用已確認，付款與分攤歷史保留；請至結算頁提出修訂或記錄人工付款。",
    "travel.expense.s06.savedPaymentsAndShares": "已存付款／分攤",
    "travel.expense.s06.payment": "付款",
    "travel.expense.s06.share": "分攤",
    "travel.expense.s06.officialSettlementSummary": "正式結算摘要",
    "travel.expense.s06.travelerBalancesFromConfirmedExpenses": "已確認費用的旅客餘額",
    "travel.expense.s06.draftsAreExcludedTheseBalancesDoNot": "待補費用不計入；以下僅為記帳摘要，不代表已付款或人工結清。",
    "travel.expense.s06.paidShareNet": "代付 {value0} · 分攤 {value1} · 淨餘額 {value2}",
    "travel.expense.s06.noConfirmedExpensesYet": "尚無已確認費用。",
    "travel.expense.s06.previousExpensesAndAccounting": "既有費用／前版帳務",
    "travel.expense.s06.originalPrecisionAndIdentityArePreservedThese": "維持原精度與身分，沒有轉換成新旅客欠款，也不重複相加。",
    "travel.expense.s06.previousExpenseNoTripDay": "{value0} · {value1} · 既有費用／未指定 Day",
    "travel.expense.s06.originalNet": "{value0} {value1} · 原淨餘額 {value2}",
    "travel.expense.s06.legacyMember": "既有會員",
    "travel.expense.s06.previousTraveler": "前版旅客",
    "travel.expense.s06.confirmTripDayOrTimeChange": "確認調整行程日或時間",
    "travel.expense.s06.previousDateTimeNewDateTimeOriginal": "原記帳日期 {value0}，發生時間 {value1}；新日期 {value2}，發生時間 {value3}。原值及操作者會保留。",
    "travel.expense.s06.confirmChangeAndSaveDraft": "確認調整並儲存待補",
    "travel.expense.s06.cancel": "取消",
    "travel.expense.s06.unableToLoadSettlementRecordsCheckAccess": "無法讀取結清資料，請確認權限或重新讀取。",
    "travel.expense.s06.accountingRecordSavedNoPlatformPaymentWas": "已保存伺服器帳務紀錄；沒有執行平台金流。",
    "travel.expense.s06.unknownResultCheckTheOriginalRequestFirst": "結果 UNKNOWN：請先查證原請求，不會自動重送或更換識別。",
    "travel.expense.s06.theVersionOrSettlementBasisChangedReload": "版本或結算基礎已變更，請重新讀取後再確認。",
    "travel.expense.s06.youDoNotHaveAccountingPermission": "目前沒有帳務操作權限。",
    "travel.expense.s06.requestRejectedCheckPrecisionOutstandingAmountActual": "資料遭拒絕，請檢查精度、未結清金額、實際付款時間與授權範圍。",
    "travel.expense.s06.originalOperationVerifiedNoDuplicatePaymentOr": "已查證原操作成功，沒有重複付款或確認。",
    "travel.expense.s06.noCommittedResultFoundYetYouMay": "目前尚無已提交紀錄；可明確選擇以原識別重試。",
    "travel.expense.s06.verificationFailedTheResultRemainsUnknownCheck": "查證未成功，維持 UNKNOWN，請稍後再查證。",
    "travel.expense.s06.manualSettlementAndRevisions": "人工結清與修訂",
    "travel.expense.s06.manualPaymentsAndExpenseRevisions": "旅程結算與還款",
    "travel.expense.s06.recordOnlyCompletedActualPaymentsThisIs": "只記錄已完成的實際付款，不代表平台代付、退款或金流交易。",
    "travel.expense.s06.checkOriginalOperationResult": "查證原請求結果",
    "travel.expense.s06.retryWithOriginalKey": "使用原識別重試",
    "travel.expense.s06.reloadSettlementRecords": "重新讀取結清資料",
    "travel.expense.s06.originalNetRemainingBalance": "{value0} · 原淨餘額 {value1} · 剩餘應收付 {value2}",
    "travel.expense.s06.aRevisionChangedTheSettlementBasisActual": "費用修訂已改變結算基礎。既有付款永久保留；差額可能改變應收付方向，不會自動退款。",
    "travel.expense.s06.acknowledgeRevisedBalancesAndPreservedPayments": "確認修訂後差額與保留的付款事實",
    "travel.expense.s06.recordedPayments": "已記錄付款",
    "travel.expense.s06.utcRecordedBy": "{value0} → {value1}：{value2} · {value4} UTC · 操作者 {value5}",
    "travel.expense.s06.expenseRevisions": "費用修訂",
    "travel.expense.s06.revise": "修訂「{value0}」",
    "travel.expense.s06.proposeARevisionOfficialDebtStaysUnchanged": "提出修訂，正式債務維持原版直到重新確認",
    "travel.expense.s06.revisionReason": "修訂原因",
    "travel.expense.s06.name": "名稱",
    "travel.expense.s06.actualExpenseTimeJourneyTimeZone": "實際消費時間（行程時區）",
    "travel.expense.s06.equal": "平均",
    "travel.expense.s06.exactAmounts": "個別金額",
    "travel.expense.s06.paymentDetails": "付款明細",
    "travel.expense.s06.actualSharesZeroAllowed": "實際分攤（可為零）",
    "travel.expense.s06.saveRevisionForConfirmation": "保存待重新確認修訂",
    "travel.expense.s06.cancelEditing": "取消編輯",
    "travel.expense.s06.revision": "修訂版本 {value0} · {value1}",
    "travel.expense.s06.awaitingReconfirmation": "待重新確認",
    "travel.expense.s06.cancelled": "已取消",
    "travel.expense.s06.nameAmount": "名稱：{value0} → {value1}；金額：{value2} → {value3}",
    "travel.expense.s06.fullPaymentAndShareDifferences": "修訂前後完整付款與分攤差異",
    "travel.expense.s06.afterRevision": "修訂後",
    "travel.expense.s06.beforeRevision": "修訂前",
    "travel.expense.s06.feeDiscount": "{value0} · {value1} · 服務費 {value2} · 折扣 {value3}",
    "travel.expense.s06.confirmRevisionAndRecalculateDebt": "確認此修訂並重新計算債務",
    "travel.expense.s06.cancelRevisionRetainAudit": "取消此修訂（保留稽核）",
    "travel.expense.s06.paymentMustBePositiveAndCannotExceed": "本次還款須大於零，且不可超過目前可結清金額",
    "travel.expense.s06.tripRepaymentSuggestionsUseConfirmedExpensesAnd": "還款建議不代表已付款，請只記錄實際完成的付款。",
    "travel.expense.s06.currentlySettled": "目前已結清",
    "travel.expense.s06.pays": "付款給",
    "travel.expense.s06.amountDue": "需還款 {amount}",
    "travel.expense.s06.partialRepayment": "部分還款",
    "travel.expense.s06.settleInFull": "全部結清",
    "travel.expense.s06.viewRepaymentHistory": "查看還款紀錄",
    "travel.expense.s06.paymentBeforeRevisionPreserved": " · 修訂前付款事實，已保留",
    "travel.expense.s06.historicalPaymentsAreNeverRewrittenByRevisions": "歷史付款不會因修訂或畫面操作被改寫。",
    "travel.expense.s06.currentlyOutstanding": "目前可結清 {amount}",
    "travel.expense.s06.thisRepaymentAmount": "本次還款金額",
    "travel.expense.s06.repaymentExpectedRemaining": "本次還款 {value0} {value1} · 還款後預計剩餘 {value2} {value3}",
    "travel.expense.s06.expectedSettlementPercentage": "本次預計結清比例",
    "travel.expense.s06.actualPaymentTimeUtc": "實際付款時間（UTC）",
    "travel.expense.s06.reviewRepayment": "核對還款內容",
    "travel.expense.s06.confirmThePeopleAmountAndTimeThis": "請確認對象、金額及時間。這只記錄已完成的實際付款，不會由平台轉帳。",
    "travel.expense.s06.iConfirmThisPaymentHasActuallyOccurred": "我確認上述付款已實際完成",
    "travel.expense.s06.recordCompletedPayment": "確認記錄已完成付款",
    "travel.expense.s06.backToEdit": "返回修改",
    "travel.expense.s06.entry": "記帳",
    "travel.expense.s06.details": "明細",
    "travel.expense.s06.settlement": "結算",
    "travel.expense.s06.advanced": "展開付款、分攤與進階明細",
    "travel.expense.s06.revisionAdvanced": "展開修訂明細",
    "travel.expense.s06.emptyDay": "這一天尚無費用，先輸入金額儲存待補。",
    "travel.expense.s06.emptyPayments": "尚無已記錄付款。",
    "travel.expense.s06.emptyRevisions": "尚無修訂。",
    "travel.expense.s06.loadingClosing": "正在讀取結算資料…",
    "travel.expense.s06.pending": "待補",
    "travel.expense.s06.deniedRead": "目前沒有查看此帳本的權限。",
    "travel.expense.s06.validAmount": "請輸入有效的非負金額",
    "travel.expense.s06.precision": "此幣別只允許 {scale} 位有效小數",
    "travel.expense.s06.validDay": "請選擇日期完整的行程日",
    "travel.expense.s06.positiveBase": "基礎金額必須大於零",
    "travel.expense.s06.timeWithZone": "實際發生時間（{zone}）",
    "travel.expense.s06.repaymentPreview": "本次還款 {amount} · 還款後預計剩餘 {remaining}",
    "travel.expense.s06.personMoney": "{person} · {amount}",
    "travel.expense.s06.lineMoney": "{role}：{amount}",
    "travel.expense.s06.savedLine": "{person} · {role} {amount}",
    "travel.expense.s06.entryAmount": "{amount} · {state}",
    "travel.expense.s06.compatibility": "新帳務僅採已確認 Traveler 費用；既有帳務保持原精度，沒有轉換或重複合計。",
    "travel.expense.s06.flow": "{payer} 付款給 {payee}",
    "travel.expense.s06.busy": "處理中…",
    "travel.expense.s06.paymentHistoryLine": "{amount} · {time} UTC{revision}",
    "travel.expense.s06.settlementData": "結算資料與重新讀取",
    "travel.expense.s06.quickEntryEntrance": "旅費快速記帳入口",
    "travel.expense.s06.entryExplanation": "快速暫存、多人付款及實際旅客分攤。下方舊版列表不包含 S06 待補或多人付款費用。",
    "travel.expense.s06.groupsFailed": "無法取得可用的旅遊團，請確認權限後重試。",
    "travel.expense.s06.openLedger": "開啟旅費記帳",
    "travel.expense.s06.groupLedger": "旅遊團記帳",
    "travel.expense.s06.noGroups": "此行程目前沒有可用的旅遊團帳務範圍。",
    "travel.expense.s06.pendingRevisionNotice": "有待重新確認的修訂；目前結算仍採用原確認版本。",
    "travel.expense.s06.noOutstanding": "目前沒有未結清款項。",
    "travel.expense.s06.noSuggestions": "尚無可用還款建議，請先確認費用明細。"
  },
  "en_US": {
    "travel.expense.s06.unableToLoadTheLedgerCheckAccess": "Unable to load the ledger. Check access and base currency, or try again later.",
    "travel.expense.s06.expenseConfirmedAndIncludedInSettlement": "Expense confirmed and included in settlement.",
    "travel.expense.s06.draftSavedNoDebtHasBeenCreated": "Draft saved. No debt has been created.",
    "travel.expense.s06.resultUnconfirmedCheckTheOriginalRequestBefore": "Result unconfirmed. Check the original request before submitting anything else.",
    "travel.expense.s06.theVersionHasChangedReloadAndReview": "The version has changed. Reload and review again.",
    "travel.expense.s06.youDoNotHavePermissionToManage": "You do not have permission to manage these expenses.",
    "travel.expense.s06.unableToSaveCheckCurrencyPrecisionPayment": "Unable to save. Check currency precision, payment and share totals, trip day and actual time.",
    "travel.expense.s06.serverStateRetrievedReviewItBeforeContinuing": "Server state retrieved. Review it before continuing.",
    "travel.expense.s06.theOriginalResultWasNotFoundYou": "The original result was not found. You may explicitly retry with the same key; nothing is resent automatically.",
    "travel.expense.s06.theOriginalRequestSucceededWithoutCreatingA": "The original request succeeded without creating a duplicate.",
    "travel.expense.s06.theOriginalRequestWasRejectedCheckThe": "The original request was rejected. Check the details before submitting again.",
    "travel.expense.s06.theOriginalResultStillNeedsCheckingNo": "The original result still needs checking. No automatic retry or new key will be used.",
    "travel.expense.s06.travelExpenses": "Travel expenses",
    "travel.expense.s06.loadingLedger": "Loading ledger…",
    "travel.expense.s06.reload": "Reload",
    "travel.expense.s06.backToJourney": "Back to journey",
    "travel.expense.s06.traveler": "Traveler {value0}",
    "travel.expense.s06.expensesAndSharing": "Expenses and sharing",
    "travel.expense.s06.previousExpenses": "Previous expenses",
    "travel.expense.s06.expenseNavigation": "Expense navigation",
    "travel.expense.s06.tripDay": "Trip day",
    "travel.expense.s06.day": "Day {value0} · {value1}",
    "travel.expense.s06.dateNotSet": "Date not set",
    "travel.expense.s06.theJourneyTimeZoneIsMissingOr": "The journey time zone is missing or invalid. Day 1 is selected; set a valid time zone before confirming expenses.",
    "travel.expense.s06.dayIsTheDefaultOutsideTheTrip": "{value0} · {value1} · Day 1 is the default outside the trip dates",
    "travel.expense.s06.reloadAndApplyServerExpense": "Reload and apply server expense",
    "travel.expense.s06.thisExpenseIsNoLongerAccessibleReopen": "This expense is no longer accessible. Reopen the ledger.",
    "travel.expense.s06.latestServerDataAppliedReviewItBefore": "Latest server data applied. Review it before submitting.",
    "travel.expense.s06.checkOriginalRequest": "Check original request",
    "travel.expense.s06.retryWithOriginalRequestKey": "Retry with original request key",
    "travel.expense.s06.quickEntry": "Quick entry",
    "travel.expense.s06.addExpenseQuickly": "Add expense quickly",
    "travel.expense.s06.amount": "Amount",
    "travel.expense.s06.saveDraft": "Save draft",
    "travel.expense.s06.enterOnlyTheAmountNowAddPayments": "Enter only the amount now. Add payments and shares later.",
    "travel.expense.s06.untitledExpense": "Untitled expense",
    "travel.expense.s06.draftNoDebtCreated": "Draft · no debt created",
    "travel.expense.s06.confirmed": "Confirmed",
    "travel.expense.s06.originalTripDayDeleted": "Original trip day deleted · {value0}",
    "travel.expense.s06.tripDateChangedOriginalExpenseDate": "Trip date changed · original expense date {value0}",
    "travel.expense.s06.paymentDetailsAdded": "Payment details added",
    "travel.expense.s06.payerNotSet": "Payer not set",
    "travel.expense.s06.viewDetails": "View details",
    "travel.expense.s06.expenseDetails": "Expense details",
    "travel.expense.s06.chooseAnExpenseFromTheListFirst": "Choose an expense from the list first.",
    "travel.expense.s06.expenseName": "Expense name",
    "travel.expense.s06.originalTripDayDeletedChooseANew": "Original trip day deleted; choose a new date explicitly",
    "travel.expense.s06.baseAmount": "Base amount",
    "travel.expense.s06.serviceFee": "Service fee",
    "travel.expense.s06.discount": "Discount",
    "travel.expense.s06.totalBaseFeeDiscountPaymentsAndShares": "Total {value0} = base + fee − discount. Payments and shares must both match the total.",
    "travel.expense.s06.checkAmount": "Check amount",
    "travel.expense.s06.category": "Category",
    "travel.expense.s06.addLater": "Add later",
    "travel.expense.s06.actualTime": "Actual time (",
    "travel.expense.s06.journeyLocalTime": "Journey local time",
    "travel.expense.s06.note": "Note",
    "travel.expense.s06.showDepartedTravelersForHistoricalExpenses": "Show departed travelers for historical expenses",
    "travel.expense.s06.historicalEntriesRequireVerifiedActualTimesCosts": "Historical entries require verified actual times; costs incurred after departure cannot be assigned.",
    "travel.expense.s06.sharedPayments": "Shared payments",
    "travel.expense.s06.selectTheActualPayersAndEnterEach": "Select the actual payers and enter each amount paid.",
    "travel.expense.s06.paymentAmount": "{value0} payment amount",
    "travel.expense.s06.totalPaid": "Total paid {value0}",
    "travel.expense.s06.actualParticipantsAndShares": "Actual participants and shares",
    "travel.expense.s06.sharingMethod": "Sharing method",
    "travel.expense.s06.equalShares": "Equal shares",
    "travel.expense.s06.exactAmountsZeroAllowed": "Exact amounts (zero allowed)",
    "travel.expense.s06.unselectedTravelersOweNothingTheWholeGroup": "Unselected travelers owe nothing. The whole group is not added automatically.",
    "travel.expense.s06.shareAmount": "{value0} share amount",
    "travel.expense.s06.totalShares": "Total shares {value0}",
    "travel.expense.s06.noTravelersSelected": "No travelers selected",
    "travel.expense.s06.confirmExpenseTripDayAndTimeFor": "Confirm expense, trip day and time for settlement",
    "travel.expense.s06.thisExpenseIsConfirmedPaymentAndShare": "This expense is confirmed. Payment and share history is preserved. Use Settlement to propose a revision or record actual payment.",
    "travel.expense.s06.savedPaymentsAndShares": "Saved payments and shares",
    "travel.expense.s06.payment": "Payment",
    "travel.expense.s06.share": "Share",
    "travel.expense.s06.officialSettlementSummary": "Official settlement summary",
    "travel.expense.s06.travelerBalancesFromConfirmedExpenses": "Traveler balances from confirmed expenses",
    "travel.expense.s06.draftsAreExcludedTheseBalancesDoNot": "Drafts are excluded. These balances do not mean payment has occurred.",
    "travel.expense.s06.paidShareNet": "Paid {value0} · Share {value1} · Net {value2}",
    "travel.expense.s06.noConfirmedExpensesYet": "No confirmed expenses yet.",
    "travel.expense.s06.previousExpensesAndAccounting": "Previous expenses and accounting",
    "travel.expense.s06.originalPrecisionAndIdentityArePreservedThese": "Original precision and identity are preserved. These amounts are not converted or counted twice.",
    "travel.expense.s06.previousExpenseNoTripDay": "{value0} · {value1} · Previous expense / no trip day",
    "travel.expense.s06.originalNet": "{value0} {value1} · Original net {value2}",
    "travel.expense.s06.legacyMember": "Legacy member",
    "travel.expense.s06.previousTraveler": "Previous traveler",
    "travel.expense.s06.confirmTripDayOrTimeChange": "Confirm trip day or time change",
    "travel.expense.s06.previousDateTimeNewDateTimeOriginal": "Previous date {value0}, time {value1}; new date {value2}, time {value3}. Original values and operator will be retained.",
    "travel.expense.s06.confirmChangeAndSaveDraft": "Confirm change and save draft",
    "travel.expense.s06.cancel": "Cancel",
    "travel.expense.s06.unableToLoadSettlementRecordsCheckAccess": "Unable to load settlement records. Check access or reload.",
    "travel.expense.s06.accountingRecordSavedNoPlatformPaymentWas": "Accounting record saved. No platform payment was executed.",
    "travel.expense.s06.unknownResultCheckTheOriginalRequestFirst": "UNKNOWN result: check the original request first. It will not be resent automatically or assigned a new key.",
    "travel.expense.s06.theVersionOrSettlementBasisChangedReload": "The version or settlement basis changed. Reload and confirm again.",
    "travel.expense.s06.youDoNotHaveAccountingPermission": "You do not have accounting permission.",
    "travel.expense.s06.requestRejectedCheckPrecisionOutstandingAmountActual": "Request rejected. Check precision, outstanding amount, actual payment time and access.",
    "travel.expense.s06.originalOperationVerifiedNoDuplicatePaymentOr": "Original operation verified. No duplicate payment or confirmation was created.",
    "travel.expense.s06.noCommittedResultFoundYetYouMay": "No committed result found yet. You may explicitly retry with the original key.",
    "travel.expense.s06.verificationFailedTheResultRemainsUnknownCheck": "Verification failed. The result remains UNKNOWN; check again later.",
    "travel.expense.s06.manualSettlementAndRevisions": "Manual settlement and revisions",
    "travel.expense.s06.manualPaymentsAndExpenseRevisions": "Trip settlement and repayments",
    "travel.expense.s06.recordOnlyCompletedActualPaymentsThisIs": "Record only completed actual payments. This is not a platform transfer, refund or payment transaction.",
    "travel.expense.s06.checkOriginalOperationResult": "Check original operation result",
    "travel.expense.s06.retryWithOriginalKey": "Retry with original key",
    "travel.expense.s06.reloadSettlementRecords": "Reload settlement records",
    "travel.expense.s06.originalNetRemainingBalance": "{value0} · Original net {value1} · Remaining balance {value2}",
    "travel.expense.s06.aRevisionChangedTheSettlementBasisActual": "A revision changed the settlement basis. Actual payments are preserved. Balances may reverse direction; no refund happens automatically.",
    "travel.expense.s06.acknowledgeRevisedBalancesAndPreservedPayments": "Acknowledge revised balances and preserved payments",
    "travel.expense.s06.recordedPayments": "Recorded payments",
    "travel.expense.s06.utcRecordedBy": "{value0} → {value1}: {value2} · {value4} UTC · Recorded by {value5}",
    "travel.expense.s06.expenseRevisions": "Expense revisions",
    "travel.expense.s06.revise": "Revise “{value0}”",
    "travel.expense.s06.proposeARevisionOfficialDebtStaysUnchanged": "Propose a revision; official debt stays unchanged until confirmation",
    "travel.expense.s06.revisionReason": "Revision reason",
    "travel.expense.s06.name": "Name",
    "travel.expense.s06.actualExpenseTimeJourneyTimeZone": "Actual expense time (journey time zone)",
    "travel.expense.s06.equal": "Equal",
    "travel.expense.s06.exactAmounts": "Exact amounts",
    "travel.expense.s06.paymentDetails": "Payment details",
    "travel.expense.s06.actualSharesZeroAllowed": "Actual shares (zero allowed)",
    "travel.expense.s06.saveRevisionForConfirmation": "Save revision for confirmation",
    "travel.expense.s06.cancelEditing": "Cancel editing",
    "travel.expense.s06.revision": "Revision {value0} · {value1}",
    "travel.expense.s06.awaitingReconfirmation": "Awaiting reconfirmation",
    "travel.expense.s06.cancelled": "Cancelled",
    "travel.expense.s06.nameAmount": "Name: {value0} → {value1}; amount: {value2} → {value3}",
    "travel.expense.s06.fullPaymentAndShareDifferences": "Full payment and share differences",
    "travel.expense.s06.afterRevision": "After revision",
    "travel.expense.s06.beforeRevision": "Before revision",
    "travel.expense.s06.feeDiscount": "{value0} · {value1} · Fee {value2} · Discount {value3}",
    "travel.expense.s06.confirmRevisionAndRecalculateDebt": "Confirm revision and recalculate debt",
    "travel.expense.s06.cancelRevisionRetainAudit": "Cancel revision (retain audit)",
    "travel.expense.s06.paymentMustBePositiveAndCannotExceed": "Payment must be positive and cannot exceed the current outstanding amount",
    "travel.expense.s06.tripRepaymentSuggestionsUseConfirmedExpensesAnd": "Suggestions are not payments. Record only payments that have actually occurred.",
    "travel.expense.s06.currentlySettled": "Currently settled",
    "travel.expense.s06.pays": "Pays",
    "travel.expense.s06.amountDue": "Amount due {amount}",
    "travel.expense.s06.partialRepayment": "Partial repayment",
    "travel.expense.s06.settleInFull": "Settle in full",
    "travel.expense.s06.viewRepaymentHistory": "View repayment history",
    "travel.expense.s06.paymentBeforeRevisionPreserved": " · Payment before revision, preserved",
    "travel.expense.s06.historicalPaymentsAreNeverRewrittenByRevisions": "Historical payments are never rewritten by revisions or screen interactions.",
    "travel.expense.s06.currentlyOutstanding": "Currently outstanding {amount}",
    "travel.expense.s06.thisRepaymentAmount": "This repayment amount",
    "travel.expense.s06.repaymentExpectedRemaining": "Repayment {value0} {value1} · Expected remaining {value2} {value3}",
    "travel.expense.s06.expectedSettlementPercentage": "Expected settlement percentage",
    "travel.expense.s06.actualPaymentTimeUtc": "Actual payment time (UTC)",
    "travel.expense.s06.reviewRepayment": "Review repayment",
    "travel.expense.s06.confirmThePeopleAmountAndTimeThis": "Confirm the people, amount and time. This only records a completed actual payment; the platform will not transfer money.",
    "travel.expense.s06.iConfirmThisPaymentHasActuallyOccurred": "I confirm this payment has actually occurred",
    "travel.expense.s06.recordCompletedPayment": "Record completed payment",
    "travel.expense.s06.backToEdit": "Back to edit",
    "travel.expense.s06.entry": "Expenses",
    "travel.expense.s06.details": "Details",
    "travel.expense.s06.settlement": "Settlement",
    "travel.expense.s06.advanced": "Payments, shares and advanced details",
    "travel.expense.s06.revisionAdvanced": "Expand revision details",
    "travel.expense.s06.emptyDay": "No expenses for this day. Enter an amount to save a draft.",
    "travel.expense.s06.emptyPayments": "No payments recorded yet.",
    "travel.expense.s06.emptyRevisions": "No revisions yet.",
    "travel.expense.s06.loadingClosing": "Loading settlement records…",
    "travel.expense.s06.pending": "To be completed",
    "travel.expense.s06.deniedRead": "You do not have permission to view this ledger.",
    "travel.expense.s06.validAmount": "Enter a valid non-negative amount",
    "travel.expense.s06.precision": "This currency allows {scale} decimal places",
    "travel.expense.s06.validDay": "Choose a trip day with a valid date",
    "travel.expense.s06.positiveBase": "Base amount must be greater than zero",
    "travel.expense.s06.timeWithZone": "Actual expense time ({zone})",
    "travel.expense.s06.repaymentPreview": "This repayment {amount} · Expected remaining {remaining}",
    "travel.expense.s06.personMoney": "{person} · {amount}",
    "travel.expense.s06.lineMoney": "{role}: {amount}",
    "travel.expense.s06.savedLine": "{person} · {role} {amount}",
    "travel.expense.s06.entryAmount": "{amount} · {state}",
    "travel.expense.s06.compatibility": "New balances use confirmed Traveler expenses only. Previous accounting retains its original precision and is not converted or counted twice.",
    "travel.expense.s06.flow": "{payer} pays {payee}",
    "travel.expense.s06.busy": "Processing…",
    "travel.expense.s06.paymentHistoryLine": "{amount} · {time} UTC{revision}",
    "travel.expense.s06.settlementData": "Settlement details and reload",
    "travel.expense.s06.quickEntryEntrance": "Quick expense entry",
    "travel.expense.s06.entryExplanation": "Save drafts quickly, add multiple payers and select actual travelers. The previous list below excludes S06 drafts and multi-payer expenses.",
    "travel.expense.s06.groupsFailed": "Unable to load available groups. Check access and try again.",
    "travel.expense.s06.openLedger": "Open travel expenses",
    "travel.expense.s06.groupLedger": "Group expenses",
    "travel.expense.s06.noGroups": "No accessible group accounting scope is available for this journey.",
    "travel.expense.s06.pendingRevisionNotice": "A revision is awaiting reconfirmation. Settlement still uses the previous confirmed version.",
    "travel.expense.s06.noOutstanding": "There are currently no outstanding amounts.",
    "travel.expense.s06.noSuggestions": "No repayment suggestions yet. Confirm expense details first."
  },
  "zh_CN": {
    "travel.expense.s06.unableToLoadTheLedgerCheckAccess": "无法读取账本，请确认权限、基准币别或稍后重试。",
    "travel.expense.s06.expenseConfirmedAndIncludedInSettlement": "费用已确认，已纳入正式结算。",
    "travel.expense.s06.draftSavedNoDebtHasBeenCreated": "已储存待补，尚未产生正式欠款。",
    "travel.expense.s06.resultUnconfirmedCheckTheOriginalRequestBefore": "结果尚未确认。请先重新读取查证，暂停其他送出。",
    "travel.expense.s06.theVersionHasChangedReloadAndReview": "数据版本已变更，请重新读取后再确认。",
    "travel.expense.s06.youDoNotHavePermissionToManage": "目前没有操作此账务的权限。",
    "travel.expense.s06.unableToSaveCheckCurrencyPrecisionPayment": "无法储存：请检查币别精度、付款／分摊合计、行程日与实际发生时间。",
    "travel.expense.s06.serverStateRetrievedReviewItBeforeContinuing": "已读取服务器实际状态，请核对后继续。",
    "travel.expense.s06.theOriginalResultWasNotFoundYou": "尚未找到原请求结果；可使用相同识别重试，不会自动重送或换新识别。",
    "travel.expense.s06.theOriginalRequestSucceededWithoutCreatingA": "原请求已确认成功，没有更换识别或重复建立。",
    "travel.expense.s06.theOriginalRequestWasRejectedCheckThe": "原请求已明确被拒绝，请检查数据后再送出。",
    "travel.expense.s06.theOriginalResultStillNeedsCheckingNo": "原请求仍须查证，请再次读取服务器状态，不会自动换识别重送。",
    "travel.expense.s06.travelExpenses": "旅费记账",
    "travel.expense.s06.loadingLedger": "正在载入账本…",
    "travel.expense.s06.reload": "重新读取",
    "travel.expense.s06.backToJourney": "返回行程",
    "travel.expense.s06.traveler": "旅客 {value0}",
    "travel.expense.s06.expensesAndSharing": "记账与分摊",
    "travel.expense.s06.previousExpenses": "既有费用",
    "travel.expense.s06.expenseNavigation": "记账层次",
    "travel.expense.s06.tripDay": "行程日",
    "travel.expense.s06.day": "第 {value0} 天 · {value1}",
    "travel.expense.s06.dateNotSet": "尚未设定日期",
    "travel.expense.s06.theJourneyTimeZoneIsMissingOr": "行程时区尚未设定或无效：预设第一天，不套用今日。确认费用前请设定有效时区。",
    "travel.expense.s06.dayIsTheDefaultOutsideTheTrip": "{value0} · {value1} · 不在行程期间时预设第一天",
    "travel.expense.s06.reloadAndApplyServerExpense": "重新读取并套用服务器费用",
    "travel.expense.s06.thisExpenseIsNoLongerAccessibleReopen": "原费用已不可存取，请重新开启账本。",
    "travel.expense.s06.latestServerDataAppliedReviewItBefore": "已套用服务器最新数据，请重新检查后送出。",
    "travel.expense.s06.checkOriginalRequest": "重新读取确认原请求",
    "travel.expense.s06.retryWithOriginalRequestKey": "使用原请求识别重试",
    "travel.expense.s06.quickEntry": "快速记账",
    "travel.expense.s06.addExpenseQuickly": "快速新增费用",
    "travel.expense.s06.amount": "金额",
    "travel.expense.s06.saveDraft": "储存待补",
    "travel.expense.s06.enterOnlyTheAmountNowAddPayments": "只填金额即可储存，之后补付款及分摊。",
    "travel.expense.s06.untitledExpense": "未命名费用",
    "travel.expense.s06.draftNoDebtCreated": "待补数据 · 不产生欠款",
    "travel.expense.s06.confirmed": "已确认",
    "travel.expense.s06.originalTripDayDeleted": "原行程日已删除 · {value0}",
    "travel.expense.s06.tripDateChangedOriginalExpenseDate": "行程日日期已变更 · 原记账日期 {value0}",
    "travel.expense.s06.paymentDetailsAdded": "已列付款明细",
    "travel.expense.s06.payerNotSet": "付款者待补",
    "travel.expense.s06.viewDetails": "查看明细",
    "travel.expense.s06.expenseDetails": "费用明细",
    "travel.expense.s06.chooseAnExpenseFromTheListFirst": "请先从记账列表选择费用。",
    "travel.expense.s06.expenseName": "费用名称",
    "travel.expense.s06.originalTripDayDeletedChooseANew": "原行程日已删除，请明确选择新日期",
    "travel.expense.s06.baseAmount": "基础金额",
    "travel.expense.s06.serviceFee": "服务费",
    "travel.expense.s06.discount": "折扣",
    "travel.expense.s06.totalBaseFeeDiscountPaymentsAndShares": "总额 {value0}＝基础金额＋服务费－折扣；确认时付款与分摊合计都必须一致。",
    "travel.expense.s06.checkAmount": "请检查金额",
    "travel.expense.s06.category": "分类",
    "travel.expense.s06.addLater": "稍后补填",
    "travel.expense.s06.actualTime": "实际发生时间（",
    "travel.expense.s06.journeyLocalTime": "行程当地时间",
    "travel.expense.s06.note": "备注",
    "travel.expense.s06.showDepartedTravelersForHistoricalExpenses": "显示已离团旅客供历史补记",
    "travel.expense.s06.historicalEntriesRequireVerifiedActualTimesCosts": "历史补记需可验证的实际发生时间，不能分摊离团后费用。",
    "travel.expense.s06.sharedPayments": "共同付款",
    "travel.expense.s06.selectTheActualPayersAndEnterEach": "请明确选取付款旅客，各自填写代付金额。",
    "travel.expense.s06.paymentAmount": "{value0} 付款金额",
    "travel.expense.s06.totalPaid": "付款合计 {value0}",
    "travel.expense.s06.actualParticipantsAndShares": "实际参与与分摊",
    "travel.expense.s06.sharingMethod": "分摊方式",
    "travel.expense.s06.equalShares": "平均分摊",
    "travel.expense.s06.exactAmountsZeroAllowed": "个别金额（可为零）",
    "travel.expense.s06.unselectedTravelersOweNothingTheWholeGroup": "未选旅客不负担费用；不会自动把全团加入。",
    "travel.expense.s06.shareAmount": "{value0} 分摊金额",
    "travel.expense.s06.totalShares": "分摊合计 {value0}",
    "travel.expense.s06.noTravelersSelected": "尚未选取旅客",
    "travel.expense.s06.confirmExpenseTripDayAndTimeFor": "确认费用（含行程日与时间）并纳入结算",
    "travel.expense.s06.thisExpenseIsConfirmedPaymentAndShare": "此费用已确认，付款与分摊历史保留；请至结算页提出修订或记录人工付款。",
    "travel.expense.s06.savedPaymentsAndShares": "已存付款／分摊",
    "travel.expense.s06.payment": "付款",
    "travel.expense.s06.share": "分摊",
    "travel.expense.s06.officialSettlementSummary": "正式结算摘要",
    "travel.expense.s06.travelerBalancesFromConfirmedExpenses": "已确认费用的旅客余额",
    "travel.expense.s06.draftsAreExcludedTheseBalancesDoNot": "待补费用不计入；以下仅为记账摘要，不代表已付款或人工结清。",
    "travel.expense.s06.paidShareNet": "代付 {value0} · 分摊 {value1} · 净余额 {value2}",
    "travel.expense.s06.noConfirmedExpensesYet": "尚无已确认费用。",
    "travel.expense.s06.previousExpensesAndAccounting": "既有费用／前版账务",
    "travel.expense.s06.originalPrecisionAndIdentityArePreservedThese": "维持原精度与身分，没有转换成新旅客欠款，也不重复相加。",
    "travel.expense.s06.previousExpenseNoTripDay": "{value0} · {value1} · 既有费用／未指定 Day",
    "travel.expense.s06.originalNet": "{value0} {value1} · 原净余额 {value2}",
    "travel.expense.s06.legacyMember": "既有会员",
    "travel.expense.s06.previousTraveler": "前版旅客",
    "travel.expense.s06.confirmTripDayOrTimeChange": "确认调整行程日或时间",
    "travel.expense.s06.previousDateTimeNewDateTimeOriginal": "原记账日期 {value0}，发生时间 {value1}；新日期 {value2}，发生时间 {value3}。原值及操作者会保留。",
    "travel.expense.s06.confirmChangeAndSaveDraft": "确认调整并储存待补",
    "travel.expense.s06.cancel": "取消",
    "travel.expense.s06.unableToLoadSettlementRecordsCheckAccess": "无法读取结清数据，请确认权限或重新读取。",
    "travel.expense.s06.accountingRecordSavedNoPlatformPaymentWas": "已保存服务器账务记录；没有执行平台金流。",
    "travel.expense.s06.unknownResultCheckTheOriginalRequestFirst": "结果 UNKNOWN：请先查证原请求，不会自动重送或更换识别。",
    "travel.expense.s06.theVersionOrSettlementBasisChangedReload": "版本或结算基础已变更，请重新读取后再确认。",
    "travel.expense.s06.youDoNotHaveAccountingPermission": "目前没有账务操作权限。",
    "travel.expense.s06.requestRejectedCheckPrecisionOutstandingAmountActual": "数据遭拒绝，请检查精度、未结清金额、实际付款时间与授权范围。",
    "travel.expense.s06.originalOperationVerifiedNoDuplicatePaymentOr": "已查证原操作成功，没有重复付款或确认。",
    "travel.expense.s06.noCommittedResultFoundYetYouMay": "目前尚无已提交记录；可明确选择以原识别重试。",
    "travel.expense.s06.verificationFailedTheResultRemainsUnknownCheck": "查证未成功，维持 UNKNOWN，请稍后再查证。",
    "travel.expense.s06.manualSettlementAndRevisions": "人工结清与修订",
    "travel.expense.s06.manualPaymentsAndExpenseRevisions": "旅程结算与还款",
    "travel.expense.s06.recordOnlyCompletedActualPaymentsThisIs": "只记录已完成的实际付款，不代表平台代付、退款或金流交易。",
    "travel.expense.s06.checkOriginalOperationResult": "查证原请求结果",
    "travel.expense.s06.retryWithOriginalKey": "使用原识别重试",
    "travel.expense.s06.reloadSettlementRecords": "重新读取结清数据",
    "travel.expense.s06.originalNetRemainingBalance": "{value0} · 原净余额 {value1} · 剩余应收付 {value2}",
    "travel.expense.s06.aRevisionChangedTheSettlementBasisActual": "费用修订已改变结算基础。既有付款永久保留；差额可能改变应收付方向，不会自动退款。",
    "travel.expense.s06.acknowledgeRevisedBalancesAndPreservedPayments": "确认修订后差额与保留的付款事实",
    "travel.expense.s06.recordedPayments": "已记录付款",
    "travel.expense.s06.utcRecordedBy": "{value0} → {value1}：{value2} · {value4} UTC · 操作者 {value5}",
    "travel.expense.s06.expenseRevisions": "费用修订",
    "travel.expense.s06.revise": "修订「{value0}」",
    "travel.expense.s06.proposeARevisionOfficialDebtStaysUnchanged": "提出修订，正式债务维持原版直到重新确认",
    "travel.expense.s06.revisionReason": "修订原因",
    "travel.expense.s06.name": "名称",
    "travel.expense.s06.actualExpenseTimeJourneyTimeZone": "实际消费时间（行程时区）",
    "travel.expense.s06.equal": "平均",
    "travel.expense.s06.exactAmounts": "个别金额",
    "travel.expense.s06.paymentDetails": "付款明细",
    "travel.expense.s06.actualSharesZeroAllowed": "实际分摊（可为零）",
    "travel.expense.s06.saveRevisionForConfirmation": "保存待重新确认修订",
    "travel.expense.s06.cancelEditing": "取消编辑",
    "travel.expense.s06.revision": "修订版本 {value0} · {value1}",
    "travel.expense.s06.awaitingReconfirmation": "待重新确认",
    "travel.expense.s06.cancelled": "已取消",
    "travel.expense.s06.nameAmount": "名称：{value0} → {value1}；金额：{value2} → {value3}",
    "travel.expense.s06.fullPaymentAndShareDifferences": "修订前后完整付款与分摊差异",
    "travel.expense.s06.afterRevision": "修订后",
    "travel.expense.s06.beforeRevision": "修订前",
    "travel.expense.s06.feeDiscount": "{value0} · {value1} · 服务费 {value2} · 折扣 {value3}",
    "travel.expense.s06.confirmRevisionAndRecalculateDebt": "确认此修订并重新计算债务",
    "travel.expense.s06.cancelRevisionRetainAudit": "取消此修订（保留审计）",
    "travel.expense.s06.paymentMustBePositiveAndCannotExceed": "本次还款须大于零，且不可超过目前可结清金额",
    "travel.expense.s06.tripRepaymentSuggestionsUseConfirmedExpensesAnd": "还款建议不代表已付款，请只记录实际完成的付款。",
    "travel.expense.s06.currentlySettled": "目前已结清",
    "travel.expense.s06.pays": "付款给",
    "travel.expense.s06.amountDue": "需还款 {amount}",
    "travel.expense.s06.partialRepayment": "部分还款",
    "travel.expense.s06.settleInFull": "全部结清",
    "travel.expense.s06.viewRepaymentHistory": "查看还款记录",
    "travel.expense.s06.paymentBeforeRevisionPreserved": " · 修订前付款事实，已保留",
    "travel.expense.s06.historicalPaymentsAreNeverRewrittenByRevisions": "历史付款不会因修订或画面操作被改写。",
    "travel.expense.s06.currentlyOutstanding": "目前可结清 {amount}",
    "travel.expense.s06.thisRepaymentAmount": "本次还款金额",
    "travel.expense.s06.repaymentExpectedRemaining": "本次还款 {value0} {value1} · 还款后预计剩余 {value2} {value3}",
    "travel.expense.s06.expectedSettlementPercentage": "本次预计结清比例",
    "travel.expense.s06.actualPaymentTimeUtc": "实际付款时间（UTC）",
    "travel.expense.s06.reviewRepayment": "核对还款内容",
    "travel.expense.s06.confirmThePeopleAmountAndTimeThis": "请确认对象、金额及时间。这只记录已完成的实际付款，不会由平台转账。",
    "travel.expense.s06.iConfirmThisPaymentHasActuallyOccurred": "我确认上述付款已实际完成",
    "travel.expense.s06.recordCompletedPayment": "确认记录已完成付款",
    "travel.expense.s06.backToEdit": "返回修改",
    "travel.expense.s06.entry": "记账",
    "travel.expense.s06.details": "明细",
    "travel.expense.s06.settlement": "结算",
    "travel.expense.s06.advanced": "展开付款、分摊与高级明细",
    "travel.expense.s06.revisionAdvanced": "展开修订明细",
    "travel.expense.s06.emptyDay": "这一天尚无费用，先输入金额保存草稿。",
    "travel.expense.s06.emptyPayments": "尚无已记录付款。",
    "travel.expense.s06.emptyRevisions": "尚无修订。",
    "travel.expense.s06.loadingClosing": "正在读取结算数据…",
    "travel.expense.s06.pending": "待补",
    "travel.expense.s06.deniedRead": "目前没有查看此账本的权限。",
    "travel.expense.s06.validAmount": "请输入有效的非负金额",
    "travel.expense.s06.precision": "此币别只允许 {scale} 位有效小数",
    "travel.expense.s06.validDay": "请选择日期完整的行程日",
    "travel.expense.s06.positiveBase": "基础金额必须大于零",
    "travel.expense.s06.timeWithZone": "实际发生时间（{zone}）",
    "travel.expense.s06.repaymentPreview": "本次还款 {amount} · 还款后预计剩余 {remaining}",
    "travel.expense.s06.personMoney": "{person} · {amount}",
    "travel.expense.s06.lineMoney": "{role}：{amount}",
    "travel.expense.s06.savedLine": "{person} · {role} {amount}",
    "travel.expense.s06.entryAmount": "{amount} · {state}",
    "travel.expense.s06.compatibility": "新账务仅采用已确认 Traveler 费用；既有账务保持原精度，没有转换或重复合计。",
    "travel.expense.s06.flow": "{payer} 付款给 {payee}",
    "travel.expense.s06.busy": "处理中…",
    "travel.expense.s06.paymentHistoryLine": "{amount} · {time} UTC{revision}",
    "travel.expense.s06.settlementData": "结算数据与重新读取",
    "travel.expense.s06.quickEntryEntrance": "旅费快速记账入口",
    "travel.expense.s06.entryExplanation": "快速暂存、多人付款及实际旅客分摊。下方旧版列表不包含 S06 草稿或多人付款费用。",
    "travel.expense.s06.groupsFailed": "无法获取可用的旅游团，请确认权限后重试。",
    "travel.expense.s06.openLedger": "打开旅费记账",
    "travel.expense.s06.groupLedger": "旅游团记账",
    "travel.expense.s06.noGroups": "此行程目前没有可用的旅游团账务范围。",
    "travel.expense.s06.pendingRevisionNotice": "有待重新确认的修订；目前结算仍采用原确认版本。",
    "travel.expense.s06.noOutstanding": "目前没有未结清款项。",
    "travel.expense.s06.noSuggestions": "尚无可用还款建议，请先确认费用明细。"
  }
};
export const getExpenseMessage=createFlatMessageLookup(expenseMessages);
